import React, {useEffect, useState} from "react";
import {
    Area,
    CartesianGrid,
    ComposedChart,
    ResponsiveContainer,
    Tooltip as ChartTooltip,
    XAxis,
    YAxis,
} from "recharts";
import {Card, Spin} from 'antd';
import moment from "moment";
import Api from "../../api";
import {LoadingOutlined} from "@ant-design/icons";
import DashboardChartTitle from "./dashboard-chart-title";
import {
    DASHBOARD_AXIS_TICK,
    DASHBOARD_Y_AXIS_WIDTH,
    formatCompactNumber,
    formatDashboardXAxis,
    getDashboardDefaultDateRange,
} from "./dashboard-chart-utils";

const DailyRegistrations = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadData = (startDate, endDate) => {
        const query = startDate && endDate ? `?start_date=${startDate}&end_date=${endDate}` : null;

        setLoading(true);

        Api.get('/admin/daily-signups' + query).then(res => {
            setData(res.data);
            setLoading(false);
        })
    };

    useEffect(() => {
        const {startDate, endDate} = getDashboardDefaultDateRange();
        loadData(startDate, endDate);
    }, []);

    const handleRangeChange = (dates, dateStrings) => {
        if (dates) {
            loadData(dateStrings[0], dateStrings[1]);
        } else {
            const {startDate, endDate} = getDashboardDefaultDateRange();
            loadData(startDate, endDate);
        }
    };

    const totalUsers = data.reduce((sum, item) => sum + (Number(item.user_count) || 0), 0);

    return (
        <Card
            className="dashboard-chart-card"
            title={
                <DashboardChartTitle
                    title="Registrations"
                    value={totalUsers}
                    tagColor="orange"
                    chartColor="orange"
                    onRangeChange={handleRangeChange}
                />
            }
            bordered={false}
        >

            {loading && (
                <Spin indicator={<LoadingOutlined style={{fontSize: 30}} spin/>} className="spinner-loader"/>
            )}

            <div className="dashboard-chart">
                <ResponsiveContainer width="100%" height={165}>
                <ComposedChart
                    data={data}
                    syncId="registrationsChart"
                    margin={{
                        top: 8,
                        right: 8,
                        left: 0,
                        bottom: 0,
                    }}
                >
                    <defs>
                        <linearGradient id="colorUv5" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="orange" stopOpacity={0.3}/>
                            <stop offset="95%" stopColor="orange" stopOpacity={0}/>
                        </linearGradient>
                    </defs>

                    <CartesianGrid strokeDasharray="3 3"/>

                    <XAxis
                        tickFormatter={formatDashboardXAxis}
                        tick={DASHBOARD_AXIS_TICK}
                        minTickGap={4}
                        interval="preserveStartEnd"
                        type="category"
                        dataKey="registration_date"
                    />

                    <YAxis
                        width={DASHBOARD_Y_AXIS_WIDTH}
                        tick={DASHBOARD_AXIS_TICK}
                        tickFormatter={formatCompactNumber}
                        type="number"
                    />

                    <ChartTooltip labelFormatter={(value) => (moment(new Date(value)).format('DD.MM.YYYY'))}/>

                    <Area
                        type="monotone"
                        name="Uued liitujad"
                        dataKey="user_count"
                        stroke="orange"
                        fill="url(#colorUv5)"
                    />
                </ComposedChart>
            </ResponsiveContainer>
            </div>
        </Card>
    );
}

export default DailyRegistrations;